<template>
  <Modal v-if="showModalPickedUpReservation" @close="closeAllModal">
    <div class="pickedUpReservation">
      <div class="pickedUpReservation__header">
        <p class="text">
          {{ $t('pickedUpRevervation') }}
        </p>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt="CloseModal"
          @click="closeAllModal"
        />
      </div>
      <div class="pickedUpReservation__buttons">
        <Button
          variant="filled"
          :title="$t('verifySSN')"
          @click="openVerifySSN"
        />
        <Button
          variant="filled"
          :title="$t('pickupForAnotherSSN')"
          @click="openPickupForAnotherSSN"
        />
        <Button
          v-if="!activeReservations.req_ph_ssn"
          variant="filled"
          :title="$t('verify')"
          @click="openVerifyWithoutSSN"
        />
        <Button
          variant="notBordered"
          :title="$t('no')"
          @click="closeAllModal"
        />
      </div>
      <div class="pickedUpReservation__verifySSN" v-if="isVerifySSN">
        <Input
          v-for="el in inputsVerifySSN"
          :key="el.value"
          type="text"
          :name="el.value"
          v-model="el.value"
          :forName="el.value"
          :label="el.label"
          :validation="el.validation"
          :validationMessages="{
            required: $t('validation.required')
          }"
          @input="handleChange"
        />
        <Button
          variant="filled"
          :title="$t('verifySSN')"
          @click="verifySSNRequest"
        />
      </div>
      <div
        class="pickedUpReservation__withAnotherSSN"
        v-if="isPickUpWithAnotherSSN"
      >
        <Input
          v-for="el in inputsSSN"
          :key="el.value"
          type="text"
          :name="el.value"
          v-model="el.value"
          :forName="el.value"
          :label="el.label"
          :validation="el.validation"
          :validationMessages="{
            required: $t('validation.required')
          }"
          @change="handleChange"
        />
        <Checkbox
          name="pickUpWithAnotherSSN"
          :value="pickUpWithAnotherSSN"
          :title="$t('pickUpWithAnotherSSN')"
          @change="pickUpWithAnotherSSN = !pickUpWithAnotherSSN"
        />
        <Button
          :variant="pickUpWithAnotherSSN ? 'filled' : 'disabledBackground'"
          :title="$t('pickupForAnotherSSN')"
          @click="pickUpWithAnotherSSN ? checkFormData() : ''"
        />
      </div>
      <div class="pickedUpReservation__verify" v-if="isOpenVerifyWithoutSSN">
        <Input
          v-for="el in inputsVerifyWithoutSSN"
          :key="el.value"
          type="text"
          :name="el.value"
          v-model="el.value"
          :forName="el.value"
          :label="el.label"
          :validation="el.validation"
          :validationMessages="{
            required: $t('validation.required')
          }"
          @change="handleChange"
        />
        <Checkbox
          name="pickUpWithAnotherSSN"
          :value="pickUpWithAnotherSSN"
          :title="$t('pickUpWithAnotherSSN')"
          @change="pickUpWithAnotherSSN = !pickUpWithAnotherSSN"
        />
        <Button
          :variant="pickUpWithAnotherSSN ? 'filled' : 'disabledBackground'"
          :title="$t('verifyDeliveryWithoutSSN')"
          @click="pickUpWithAnotherSSN ? verifyDeliveryWithoutSSN() : ''"
        />
      </div>
      <p v-if="isError && (ssnVerify || ssn)" class="error-verifySSN">
        {{ $t('wrongSSN') }}
      </p>
    </div>
  </Modal>
</template>

<script lang="ts">
import { InputFileEvent } from '@/types';
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import { inputsVerifySSN, inputsSSN, inputsVerifyWithoutSSN } from './configs';

@Options({
  name: 'PickedUpReservation',
  props: ['showModalPickedUpReservation', 'idDelivery', 'activeReservations'],
  directives: {
    focus: {
      mounted(el) {
        el.focus();
      }
    }
  },
  data() {
    return {
      ssn: '',
      ssnVerify: '',
      ssnForOtherPerson: '',
      kolliId: '',
      payloadPickupForSSN: null,
      isVerifySSN: false,
      isError: false,
      pickUpWithAnotherSSN: false,
      isOpenVerifyWithoutSSN: false,
      isPickUpWithAnotherSSN: false,
      inputsSSN: inputsSSN(this.$t),
      inputsVerifySSN: inputsVerifySSN(this.$t),
      inputsVerifyWithoutSSN: inputsVerifyWithoutSSN(this.$t)
    };
  },
  computed: {
    ...mapState('pharmacy', ['verifySSNData', 'verifyPINData']),
    isAPIReservations() {
      return this.$route.name === 'APIReservations';
    }
  },
  methods: {
    ...mapActions('pharmacy', [
      'updatePharmacyReservation',
      'verifySSN',
      'verifyPIN'
    ]),
    handleChange(e: InputFileEvent) {
      this[e.target.name] = e.target.value;
    },
    openVerifySSN() {
      this.isVerifySSN = true;

      this.ssn = '';
      this.ssnVerify = '';
      this.isError = false;
      this.isOpenVerifyWithoutSSN = false;
      this.isPickUpWithAnotherSSN = false;
    },
    openPickupForAnotherSSN() {
      this.isPickUpWithAnotherSSN = true;

      this.ssn = '';
      this.ssnVerify = '';
      this.isError = false;
      this.isVerifySSN = false;
      this.pickUpWithAnotherSSN = false;
      this.isOpenVerifyWithoutSSN = false;
    },
    openVerifyWithoutSSN() {
      this.isOpenVerifyWithoutSSN = true;

      this.isError = false;
      this.isVerifySSN = false;
      this.pickUpWithAnotherSSN = false;
      this.isPickUpWithAnotherSSN = false;
    },
    closeAllModal() {
      this.ssn = '';
      this.ssnVerify = '';
      this.isError = false;
      this.isVerifySSN = false;
      this.pickUpWithAnotherSSN = false;
      this.pickUpWithAnotherSSN = false;
      this.isPickUpWithAnotherSSN = false;
      this.isOpenVerifyWithoutSSN = false;
      this.$emit('closeModal');
    },
    checkFormData() {
      if (this.pickUpWithAnotherSSN && this.ssnForOtherPerson) {
        this.verifySSNRequest();
      }
    },
    async pickedUpReservationRequest(
      deliveryId: string,
      pickupForAnotherSsn: string
    ) {
      this.loading = true;

      const { id } = this.$route.params;

      if (pickupForAnotherSsn) {
        this.payloadPickupForSSN = {
          deliveryStatus: 'pickup',
          pickupForAnotherSsn
        };
      } else {
        this.payloadPickupForSSN = {
          deliveryStatus: 'pickup'
        };
      }

      await this.updatePharmacyReservation({
        data: this.payloadPickupForSSN,
        pharmacyId: id,
        deliveryId: deliveryId
      });

      this.loading = false;
      this.closeAllModal();

      return this.isAPIReservations
        ? await this.$emit('show')
        : await this.$emit('loadPickupBoxes');
    },

    async verifySSNRequest() {
      this.loading = true;

      const payload = {
        kolliId: this.kolliId,
        ssn: this.ssnVerify || this.ssn
      };

      await this.verifySSN({
        data: payload,
        deliveryId: this.idDelivery
      });

      if (this.verifySSNData) {
        if (!this.ssnForOtherPerson) {
          this.pickedUpReservationRequest(this.idDelivery);
        } else {
          this.pickedUpReservationRequest(
            this.idDelivery,
            this.ssnForOtherPerson
          );
        }
      } else {
        this.isError = true;
      }

      this.loading = false;
    },
    async verifyDeliveryWithoutSSN() {
      this.loading = true;

      const payload = {
        kolliId: this.kolliId,
        pinCode: this.pinCode,
        phoneNumber: this.phoneNumber
      };

      await this.verifyPIN({ data: payload, deliveryId: this.idDelivery });
      this.loading = false;

      if (this.verifySSNData) {
        this.pickedUpReservationRequest(this.idDelivery);
      } else {
        this.isError = true;
      }
    }
  }
})
export default class PickedUpReservation extends Vue {}
</script>

<style lang="scss" scoped>
.pickedUpReservation {
  max-width: 536px;
  height: 100%;
  padding: 24px;
  .pickedUpReservation__header {
    display: flex;
    justify-content: space-between;
    padding-bottom: 24px;
    .text {
      color: $label;
      font-size: $fourteenSize;
      line-height: $twentyTwoSize;
      font-weight: 500;
    }
    img {
      cursor: pointer;
    }
  }
  .pickedUpReservation__buttons {
    display: flex;
    align-items: center;
    & > * {
      margin-right: 12px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .pickedUpReservation__verifySSN {
    margin-top: 30px;
    .input {
      width: 100%;
    }
    label {
      position: absolute;
      top: -6px;
      left: 15px;
      font-family: 'Ubuntu-Regular';
      padding: 0 5px;
      background: $white;
      color: $label;
      font-weight: 400;
      font-size: $twelveSize;
      line-height: $fourteenSize;
      z-index: 1;
    }
    input {
      width: 100%;
      height: 48px;
      font-size: 14px;
      border-radius: 8px;
      border: 1px solid $border;
      padding: 0 0 0 15px;
      box-sizing: border-box;
      color: $main-text;
      font-family: 'Ubuntu-Regular';
      outline: none;
      margin-bottom: 0;
    }
  }
  .pickedUpReservation__withAnotherSSN,
  .pickedUpReservation__verify {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
    .button {
      margin-left: 12px;
    }
  }
  .pickedUpReservation__verify {
    align-items: flex-start;
    flex-direction: column;
    .input {
      width: 100%;
    }
    .button {
      margin-left: 0;
      margin-top: 30px;
    }
  }
  .pickedUpReservation__withAnotherSSN {
    align-items: flex-start;
    flex-direction: column;
    .button {
      margin-top: 30px;
      margin-left: 0;
    }
    .input {
      width: 100%;
      .formkit-wrapper {
        .formkit-inner {
          .formkit-input {
            width: 100%;
            height: 48px;
            font-size: 14px;
            border-radius: 8px;
            border: 1px solid $border;
            padding: 0 0 0 15px;
            box-sizing: border-box;
            color: $main-text;
            font-family: 'Ubuntu-Regular';
            outline: none;
            margin-bottom: 32px;
          }
        }
      }
    }
  }
  .error-verifySSN {
    font-size: $twelveSize;
    color: $red;
    padding-top: 32px;
  }
}
</style>
